import { render, staticRenderFns } from "./TaxSetupBase.vue?vue&type=template&id=53142200&"
import script from "./TaxSetupBase.vue?vue&type=script&lang=js&"
export * from "./TaxSetupBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports